











/**
 * A loading component for use anywhere delayed content may be needed.
 *
 * It either displays the content provided in the default slot or in
 * the `owc-loader` slot, depending on whether the `isLoading` property
 * is `false` or `true`, respectively.
 *
 * If a custom loader is needed, it may be provided via the `owc-loader`
 * named slot.
 */
export default {
  name: 'owc-loading',
  props: {
    mode: {
      type: String,
      default: 'dark',
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
};
